import { useMutation, useQueryClient } from '@tanstack/react-query'

import { post } from '../apiClient'
import { type CancelReservationBody } from '../../../common/validations/reservationSchema'
import {
  CancelReservationResponse,
  CancelReservationResponseSchema,
} from '../../../common/generated/residentApiSchemas'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export type CancelReservationRequest = CancelReservationBody

export const useAPICancelReservation = (contractId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      request: CancelReservationRequest
    ): Promise<CancelReservationResponse> => {
      const response = await post(
        `/contracts/${contractId}/reservations/cancel`,
        request as unknown as Record<string, unknown>,
        CancelReservationResponseSchema
      )
      return response
    },
    throwOnError: false,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['reservations', contractId],
      })

      queryClient.invalidateQueries({
        queryKey: [
          `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`,
        ],
      })

      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as string
          return (
            key?.includes(
              `${API_ENDPOINTS.CONTRACTS}/${contractId}/reservation-calendars`
            ) && key?.includes('/time-slots')
          )
        },
      })
    },
  })
}
